module.exports = __webpack_public_path__ + "static/img/course-details-bg.76c520a6.png";